var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboard = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5C3 3.89543 3.89543 3 5 3H9.25C10.3546 3 11.25 3.89543 11.25 5V10.25C11.25 11.3546 10.3546 12.25 9.25 12.25H5C3.89543 12.25 3 11.3546 3 10.25V5ZM5 5H9.25V10.25H5V5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 13.75C12.75 12.6454 13.6454 11.75 14.75 11.75H19C20.1046 11.75 21 12.6454 21 13.75V19C21 20.1046 20.1046 21 19 21H14.75C13.6454 21 12.75 20.1046 12.75 19V13.75ZM14.75 13.75H19V19H14.75V13.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 3C13.6454 3 12.75 3.89543 12.75 5V8.5C12.75 9.60457 13.6454 10.5 14.75 10.5H19C20.1046 10.5 21 9.60457 21 8.5V5C21 3.89543 20.1046 3 19 3H14.75ZM19 5H14.75V8.5H19V5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 15.5C3 14.3954 3.89543 13.5 5 13.5H9.25C10.3546 13.5 11.25 14.3954 11.25 15.5V19C11.25 20.1046 10.3546 21 9.25 21H5C3.89543 21 3 20.1046 3 19V15.5ZM5 15.5H9.25V19H5V15.5Z",
    fill: "currentColor"
  })));
};
export default SvgDashboard;